import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import NIBg from 'products/global/assets/img/signup/bg-NI.svg';
import RHBg from 'products/global/assets/img/signup/bg-RH.svg';
import { sizes } from 'style';
import { motion } from 'framer-motion';
import { PRODUCTS } from '../../consts';

const Background = styled(motion.img)`
  position: absolute;
  width: 100%;
  height: auto;
  bottom: 0;
  left: 0;
`;

const Overlay = styled.div`
  background: rgb(39, 60, 73);
  background: linear-gradient(180deg, rgba(39, 60, 73, 1) 15%, rgba(0, 212, 255, 0) 100%);
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;

  @media ${sizes.desktop} {
    background: linear-gradient(
      90deg,
      rgba(39, 60, 73, 1) 10%,
      rgba(0, 212, 255, 0) 100%
    );
  }
`;

const ChooseProductBackground = ({ selectedProduct }) => {
  const getSrc = () => {
    switch (selectedProduct.name) {
      case PRODUCTS.REMOTE_HEALTH.name:
        return RHBg;
      default:
        return NIBg;
    }
  };

  return (
    <>
      {selectedProduct && (
        <Background initial={{ opacity: 0 }} animate={{ opacity: 1 }} src={getSrc()} />
      )}
      <Overlay />
    </>
  );
};

ChooseProductBackground.propTypes = {
  selectedProduct: PropTypes.object
};

export default ChooseProductBackground;
